import PageHeading from "Layout/AppMain/PageHeading";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Card, CardBody, InputGroup, CardFooter, Button, Input, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup } from "reactstrap";
import InputWrapper from "Pages/Profile/InputWrapper";
import DropdownList from "react-widgets/DropdownList";
import DatePicker, { registerLocale } from "react-datepicker";
import { ReactComponent as EditPen } from "../../../../../assets/utils/images/svgs/editPen.svg";
import { ReactComponent as Add } from "../../../../../assets/utils/images/svgs/Add.svg";
import nl from "date-fns/locale/nl";
import moment from "moment";
import GroupStatus from "Components/IconDropdown/Cross_Tick/GroupStatus";
import { ReactComponent as CalenderIcon } from "../../../../../assets/utils/images/svgs/CalenderIcon.svg";
import { ReactComponent as CalendarIcon } from "../../../../../assets/utils/images/svgs/calendar-blue.svg"
import { BsQuestionCircle } from "react-icons/bs";

registerLocale("nl", nl);

const Step1 = ({ formDataState, setFormDataState, setStep, communityId, setCommunityId, getSchoolList, communityData }) => {
    const [dagdelenDisable, setDagdelenDisable] = useState(false)

    const [communityIdError, setCommunityIdError] = useState(false)
    const [datePickerError, setDatePickerError] = useState('')
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [terGoedkeuringError, setTerGoedkeuringError] = useState('')
    const [emailError, setEmailError] = useState(false)
    const [memoIsOpen, setMemoIsOpen] = useState(false)
    const [selectedDate, setSelectedDate] = useState(false);
    const [checkedStates, setCheckedStates] = useState(
        new Array(formDataState.emailList.length).fill(true)
    );
    const [isTerGoedkeuringSelected, setIsTerGoedkeuringSelected] = useState(
        formDataState.rdApproved !== null && formDataState.rdApproved !== undefined
    );

    const questionCircleIconRef = useRef();

    const datePickerRefs = useRef([]);
    const isInitialMount = useRef(true);

    useEffect(() => {
        setIsTerGoedkeuringSelected(
            formDataState.rdApproved !== null &&
            formDataState.rdApproved !== undefined
        );
    }, [formDataState.rdApproved]);

    useEffect(() => {
        if (!communityData?.data) return;

        const bShowProlonged = communityData.data.bShowProlonged;
        const isProlonged = bShowProlonged === "Y";

        setDagdelenDisable(!isProlonged);

        setFormDataState(prev => ({
            ...prev,
            communityData,
            bShowProlonged,

            // Only set defaults if these values don't exist yet
            selectLangeContract:
                prev.selectLangeContract === undefined
                    ? true
                    : prev.selectLangeContract,

            selectDagdelen:
                prev.selectDagdelen === undefined
                    ? true
                    : prev.selectDagdelen,
        }));
    }, [communityData]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }

        setFormDataState(prevState => ({
            ...prevState,
            rdApproved: null,
            vMelderReminder: "",
            informText: updateInformText(null)
        }));
    }, [formDataState.startDate, formDataState.endDate]);

    useEffect(() => {
        setDagdelenDisable(formDataState.bShowProlonged !== "Y");
    }, [formDataState.bShowProlonged]);

    const handleDatepicker = (e) => {
        if (e) e.stopPropagation();
        setIsDatePickerOpen((prevState) => !prevState);
    };
    const toggleCheckbox = (type, value) => {

        if (type == 'selectLangeContract') {
            if (value == false) {
                setDagdelenDisable(true)
                setFormDataState({
                    ...formDataState,
                    selectLangeContract: false,
                    selectDagdelen: true,
                })
            }
            else {
                setDagdelenDisable(false)
                setFormDataState({
                    ...formDataState,
                    selectLangeContract: true,
                    selectDagdelen: true,
                })
            }
        }
        else if (type == 'selectDagdelen') {
            if (value == "0") {
                setFormDataState({
                    ...formDataState,
                    selectLangeContract: true,
                    selectDagdelen: false,
                })
            }
            else {
                setFormDataState({
                    ...formDataState,
                    selectLangeContract: true,
                    selectDagdelen: true,
                })
            }
        }
    }

    const updateInformText = (value) => {
        if (value === 1) {
            return `Op www.clooser.nl staat de weekstaat van %SCHOOL% %ORGANISATIE% voor de periode van %FROM_DATE% t/m %TO_DATE% voor u klaar.\nWilt u inloggen op www.clooser.nl en de weekstaat van bovenstaande periode beoordelen.\nIndien u de weekstaat wenst af te keuren dient u dit online toe te lichten.\nDeze mail is een systeembericht, u kunt hier niet op antwoorden.`
        } else return `Op www.clooser.nl staat de weekstaat van %SCHOOL% %ORGANISATIE% voor de periode van %FROM_DATE% t/m %TO_DATE% voor u klaar.`
    }

    const handleApproveClick = (_, value) => {

        if (value === "1") {
            setFormDataState({
                ...formDataState,
                rdApproved: parseInt(value),
                selectCoordinator: false,
                selectSchool: true,
                selectSalarisAdmin: false,
                selectCoordinatorAttach: false,
                selectSchoolAttach: false,
                selectSalarisAdminAttach: false,
                informText: updateInformText(1)
            })
        }
        else {
            setFormDataState({
                ...formDataState,
                rdApproved: parseInt(value),
                selectCoordinator: true,
                selectSchool: true,
                selectSalarisAdmin: false,
                selectCoordinatorAttach: true,
                selectSchoolAttach: true,
                selectSalarisAdminAttach: true,
                informText: updateInformText(0)
            })
        }
    }

    const toggleInformCheckboxes = (type, value) => {
        if (value === true || value === "1") {
            setFormDataState({ ...formDataState, [type]: true })
        }
        else {
            setFormDataState({ ...formDataState, [type]: false })
        }
    }

    const setEmailValue = (value) => {
        setFormDataState({ ...formDataState, informEmail: value })
    }

    function validateEmailList() {
        var emails = (formDataState.informEmail).split(',')
        var valid = true;
        var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        for (var i = 0; i < emails.length; i++) {
            if (emails[i] === "" || !regex.test(emails[i].replace(/\s/g, ""))) {
                valid = false;
            }
        }
        return valid;
    }

    const addEmail = () => {
        if (formDataState.informEmail.trim() !== '') {
            validateEmailList();
            if (validateEmailList() == true) {
                setEmailError(false)
                setFormDataState({
                    ...formDataState,
                    emailList: [...formDataState.emailList, formDataState.informEmail],
                    informEmail: ''
                });
                setCheckedStates((prevState) => [...prevState, true]);
            }
            else {
                setEmailError(true)
            }
        };
    }

    const handleEmailCheckbox = (index) => {
        const updatedCheckedStates = checkedStates.map((item, idx) =>
            idx === index ? !item : item
        );

        setCheckedStates(updatedCheckedStates);
    };

    const handleSubmit = () => {
        var startDate = moment(formDataState.startDate);
        var endDate = moment(formDataState.endDate);
        var difference = endDate.diff(startDate, 'days');
        var selectedEmails = formDataState.emailList.filter((_, idx) => checkedStates[idx]);

        const isRdApprovedNull = formDataState.rdApproved === null;
        const isCommunityId = communityId <= 0;
        setCommunityIdError(isCommunityId);

        isRdApprovedNull && setTerGoedkeuringError(true);
        if (formDataState.startDate != "" && formDataState.endDate != "") {
            if ((difference < 62) && (difference > 0)) {
                if (!isRdApprovedNull && !isCommunityId) {
                    setFormDataState({
                        ...formDataState, datePickerStyle: "weekstaten-datePicker form-control",
                        informEmail: selectedEmails
                    })
                    setStep('step2');
                }
            }
            else {
                setFormDataState({ ...formDataState, datePickerStyle: "travelCost-datePicker-error" })
                setDatePickerError('Opmerking: maximaal aantal te selecteren dagen zijn 62 (2 maanden).')
            }
        }
        else {
            setFormDataState({ ...formDataState, datePickerStyle: "travelCost-datePicker-error" })
            setDatePickerError('Verplicht veld')
        }
    };
    const displayDate = selectedDate
        ? selectedDate.toLocaleDateString("nl-NL")
        : "";

    const resetOrganizationFields = () => {
        setFormDataState(prev => ({
            ...prev,

            // Dates
            startDate: '',
            endDate: '',
            vMelderReminder: '',

            selectLangeContract: true,
            selectDagdelen: true,

            // Approval
            rdApproved: null,

            // Informing
            selectCoordinator: false,
            selectSchool: true,
            selectSalarisAdmin: false,

            selectCoordinatorAttach: false,
            selectSchoolAttach: false,
            selectSalarisAdminAttach: false,


            // Emails
            informEmail: '',
            emailList: [],

            // Reset email text
            informText: updateInformText(null),

            // Reset date styling/errors
            datePickerStyle: '',
        }));

        // Local states
        setSelectedDate(null);
        setIsDatePickerOpen(false);
        setIsTerGoedkeuringSelected(false);

        setCommunityIdError(false);
        setDatePickerError('');
        setTerGoedkeuringError('');
        setEmailError(false);

        setCheckedStates([]);

        // Close memo if open
        setMemoIsOpen(false);
    };

    return (
        <div>
            <div className="chat-layout-wrapper">
                <div className="app-inner-layout chat-layout">
                    <PageHeading />
                    <div className="app-inner-layout__wrapper">
                        <div className="row w-100 weekstaten-samenstellen">
                            <div className="col-xxl-5 col-12">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-xl-5 p-4 table-responsive travelCost-card-height overflow-visible samenstellen">
                                        <InputWrapper label="Selecteer organisatie *" className="text-align-left travelCost-light-text">
                                            <InputGroup>
                                                <DropdownList
                                                    placeholder="Selecteer..."
                                                    className={`travelCost-dropdownList ${communityIdError ? "error-border" : ""}`}
                                                    data={communityData?.data?.communityList}
                                                    value={
                                                        communityData?.data?.communityList?.find(
                                                            (item) => Number(item.iCommunityId) === Number(communityId)
                                                        ) || null
                                                    }
                                                    dataKey="iCommunityId"
                                                    textField="name"
                                                    onChange={(nextValue) => {
                                                        const newCommunityId = nextValue?.iCommunityId;

                                                        if (!newCommunityId) return;

                                                        setCommunityId(newCommunityId);
                                                        resetOrganizationFields();
                                                    }}
                                                    required="true"
                                                />
                                            </InputGroup>
                                        </InputWrapper>
                                        <div className="samenstellen-toggle-row d-flex align-items-center text-align-left travelCost-light-text">
                                            <div className="col-xxl-4 col-12">Toon dagdelen</div>
                                            <div className="col-xxl-8 col-12 d-flex align-items-center ms-2">
                                                <GroupStatus
                                                    disable={dagdelenDisable}
                                                    iconChangeHandler={toggleCheckbox}
                                                    field={"selectDagdelen"}
                                                    data={formDataState.selectDagdelen ? 1 : 0}
                                                />
                                            </div>
                                        </div>
                                        {
                                            formDataState.bShowProlonged !== 'N' &&
                                            <InputWrapper label="Toon Lange contracten" className="d-flx align-items-center text-align-left travelCost-light-text">
                                                <InputGroup className="justify-content-between height-100">
                                                    <div className="d-flex align-items-center">
                                                        <GroupStatus iconChangeHandler={toggleCheckbox} field={"selectLangeContract"} data={formDataState.selectLangeContract ? 1 : 0} />
                                                    </div>
                                                </InputGroup>
                                            </InputWrapper>
                                        }
                                        <InputWrapper label="Selecteer periode *" className="text-align-left travelCost-light-text">
                                            <Row className="justify-content-between">
                                                <Col xxl="6">
                                                    <Col sm={12}>
                                                        <div className="customDatePicker">
                                                            <DatePicker
                                                                ref={(el) => (datePickerRefs.current[0] = el)}
                                                                locale="nl"
                                                                selected={(formDataState.startDate !== '' && formDataState.startDate !== undefined) ? new Date(formDataState.startDate) : ''}
                                                                onChange={(val) => {
                                                                    setFormDataState(prevState => ({
                                                                        ...prevState,
                                                                        startDate: moment(val).format('YYYY-MM-DD'),
                                                                        datePickerStyle: prevState.endDate !== '' ? "weekstaten-datePicker form-control" : prevState.datePickerStyle
                                                                    }));
                                                                    formDataState?.endDate !== '' && setDatePickerError(false)
                                                                }}
                                                                placeholderText={'dd-mm-jjjj'}
                                                                dateFormat="dd-MM-yyyy"
                                                                className={`form-control w-100 ${formDataState.datePickerStyle}`}
                                                            />
                                                            <CalendarIcon onClick={() => datePickerRefs.current[0]?.setFocus()} className="svg-pointer" />
                                                        </div>
                                                    </Col>
                                                </Col>
                                                <Col xxl="6">
                                                    <Col sm={12}>
                                                        <div className="customDatePicker">
                                                            <DatePicker
                                                                ref={(el) => (datePickerRefs.current[1] = el)}
                                                                locale="nl"
                                                                className={`form-control w-100 ${formDataState.datePickerStyle}`}
                                                                selected={(formDataState.endDate !== '' && formDataState.endDate !== undefined) ? new Date(formDataState.endDate) : ''}
                                                                onChange={(val) => {
                                                                    setFormDataState(prevState => ({
                                                                        ...prevState,
                                                                        endDate: moment(val).format('YYYY-MM-DD'),
                                                                        datePickerStyle: prevState.startDate !== '' ? "weekstaten-datePicker form-control" : prevState.datePickerStyle
                                                                    }));
                                                                    formDataState?.startDate !== '' && setDatePickerError(false)
                                                                }}
                                                                showPopperArrow={false}
                                                                placeholderText={'dd-mm-jjjj'}
                                                                dateFormat="dd-MM-yyyy"
                                                            />
                                                            <CalendarIcon onClick={() => datePickerRefs.current[1]?.setFocus()} className="svg-pointer" />
                                                        </div>
                                                        <Row>
                                                            <Col md="12" lg="12" className="weekstaten-month-text">
                                                                Maximaal 2 maanden
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </InputWrapper>
                                        <InputWrapper label="" className="d-flex align-items-center text-align-left travelCost-light-text">
                                            <InputGroup className="justify-content-between">
                                                <div>
                                                    <span className="text-danger">{datePickerError}</span>
                                                </div>
                                            </InputGroup>
                                        </InputWrapper>
                                    </CardBody>
                                </Card>
                            </div>
                            <div className="col-xxl-7 col-12">
                                <Card className="main-card">
                                    <CardBody className="p-xl-5 p-4 table-responsive travelCost-card-height samenstellen">
                                        <Row >
                                            <Col md={window.innerWidth < 1500 ? "6" : "3"} className="travelCost-bold-text">
                                                Ter goedkeuring: *
                                            </Col>
                                            <Col md="2" lg="2" className="position-relative d-flex justify-content-center align-items-center travelCost-bold-text">
                                                <span className={`${isTerGoedkeuringSelected ? 'd-none' : ''} ps-3 d-flex`}>
                                                    <BsQuestionCircle className={`svg-pointer ${terGoedkeuringError ? "error-border" : ""} svg-n-size`} color="#F2983E" onClick={() => {
                                                        questionCircleIconRef.current?.props.onClick()
                                                    }} /></span>
                                                <GroupStatus IconRef={questionCircleIconRef} isTerGoedkeuringSelected={isTerGoedkeuringSelected} setIsTerGoedkeuringSelected={setIsTerGoedkeuringSelected} iconChangeHandler={handleApproveClick} field={"selectCoordinator"} data={formDataState.rdApproved ? 1 : 0} />
                                                {
                                                    (terGoedkeuringError && !isTerGoedkeuringSelected) &&
                                                    <span className="text-danger error-left-absolute">Ter goedkeuring is verplicht</span>
                                                }
                                            </Col>
                                        </Row>
                                        {
                                            (formDataState.rdApproved === 1) ? (
                                                <Row className="mb-2">
                                                    <Col md={window.innerWidth < 1500 ? "6" : "3"} className="travelCost-light-text">
                                                        Herinneringsmail
                                                    </Col>

                                                    <Col className="ms-md-0 ms-lg-5">
                                                        <ButtonGroup style={{ height: 'min-content' }} className="me-2 ">
                                                            <Button
                                                                outline
                                                                className='btn-color-style btn-datepicker rounded d-flex align-items-center py-2 px-2'
                                                                onClick={handleDatepicker}

                                                                style={{ padding: "12px" }}
                                                            >
                                                                <span className="me-2">
                                                                    {displayDate || (formDataState.vMelderReminder) ? moment(formDataState.vMelderReminder).format('DD-MM-YYYY') : "Selecteer datum"}
                                                                </span>
                                                                <CalenderIcon />

                                                            </Button>

                                                            <DatePicker
                                                                open={isDatePickerOpen}
                                                                locale="nl"
                                                                clearButtonTitle="Clear"
                                                                selected={selectedDate}
                                                                onChange={(value) => {
                                                                    setSelectedDate(value)
                                                                    setFormDataState((prev => ({
                                                                        ...prev,
                                                                        vMelderReminder: moment(value).format('YYYY-MM-DD'),

                                                                    })))
                                                                    handleDatepicker()
                                                                }
                                                                }
                                                                popperPlacement="bottom-end"
                                                                className="hide-datepicker display-none"
                                                                minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                                            />
                                                        </ButtonGroup>
                                                    </Col>
                                                </Row>
                                            ) : null
                                        }

                                        <Row>
                                            <Col md={window.innerWidth < 1500 ? "6" : "3"} className="travelCost-light-text">
                                                Standaardtekst e-mail wijzigen
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center">
                                                <EditPen onClick={() => setMemoIsOpen(true)} className="svg-pointer" />
                                            </Col>
                                        </Row>
                                        <Row className="mt-3 mb-2">
                                            <Col md={window.innerWidth < 1500 ? "6" : "3"} className="travelCost-bold-text">
                                                Informeren
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center travelCost-bold-text">
                                                Mail
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center travelCost-bold-text">
                                                Bijlage
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center">
                                            <Col md={window.innerWidth < 1500 ? "6" : "3"} className="travelCost-light-text">
                                                Coördinator
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center">
                                                <GroupStatus iconChangeHandler={toggleInformCheckboxes} field={"selectCoordinator"} data={formDataState.selectCoordinator ? 1 : 0} />
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center">
                                                <GroupStatus iconChangeHandler={toggleInformCheckboxes} field={"selectCoordinatorAttach"} data={formDataState.selectCoordinatorAttach ? 1 : 0} />
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center">
                                            <Col md={window.innerWidth < 1500 ? "6" : "3"} className="travelCost-light-text">
                                                School
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center p-2">
                                                <GroupStatus iconChangeHandler={toggleInformCheckboxes} field={"selectSchool"} data={formDataState.selectSchool ? 1 : 0} />
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center">
                                                <GroupStatus iconChangeHandler={toggleInformCheckboxes} field={"selectSchoolAttach"} data={formDataState.selectSchoolAttach ? 1 : 0} />
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center">
                                            <Col sm="12" md={window.innerWidth < 1500 ? "6" : "3"} className="travelCost-light-text">
                                                Salaris administratie
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center ">
                                                <GroupStatus iconChangeHandler={toggleInformCheckboxes} field={"selectSalarisAdmin"} data={formDataState.selectSalarisAdmin ? 1 : 0} />
                                            </Col>
                                            <Col md="2" lg="2" className="d-flex justify-content-center">
                                                <GroupStatus iconChangeHandler={toggleInformCheckboxes} field={"selectSalarisAdminAttach"} data={formDataState.selectSalarisAdminAttach ? 1 : 0} />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2 mt-3">
                                            <Col md={window.innerWidth < 1500 ? "6" : "3"} className="travelCost-bold-text mb-4">
                                                Extra e-mail adressen
                                            </Col>
                                            <Col md="6" lg="6">
                                                <Row className="ms-xl-5">
                                                    <Col md="12" lg="12" className="d-flex px-0 align-items-center">
                                                        <Input
                                                            className={`travelCost-disabled-text ${emailError ? "error-border" : ""}`}
                                                            placeholder="lemand@school1.nl. Il@school2.l, ..."
                                                            value={formDataState.informEmail}
                                                            onChange={(e) => { setEmailValue(e.target.value) }}
                                                        />
                                                        <Add className="ms-2 add-circle-lg-svg" onClick={addEmail} />
                                                    </Col>
                                                </Row>
                                                {
                                                    emailError &&
                                                    <Row className="travelCost-light-text weekstaten-email-margin">
                                                        <Col md="12" lg="12" className="text-danger">
                                                            ongeldig e-mail
                                                        </Col>
                                                    </Row>
                                                }
                                                <Row className="travelCost-light-text ms-xl-5">
                                                    <Col md="12" lg="12" className="px-0">
                                                        Gebruik bij meerdere e-mail adressen een komma als scheidingsteken.
                                                    </Col>
                                                </Row>

                                            </Col>
                                        </Row>
                                        {formDataState.emailList.map((email, index) => (
                                            <Row key={index} className="align-items-center">
                                                <Col md={window.innerWidth < 1500 ? "6" : "4"} className="travelCost-light-text"></Col>
                                                <Col md={window.innerWidth < 1500 ? "6" : "4"} className="d-flex justify-content-start p-2 informEmail-margin">
                                                    <Input
                                                        type="checkbox"
                                                        className="col-md-12"
                                                        checked={checkedStates[index]}
                                                        onChange={() => handleEmailCheckbox(index)}
                                                    />
                                                    <div className="ps-2">{email}</div>
                                                </Col>
                                            </Row>
                                        ))}
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="chat-layout-footer verzoken-footer-height">
                    <CardFooter className="chat-layout-footer__inner">
                        <div className="d-flex justify-content-end w-100">
                            <div className="me-3">
                                <Button
                                    outline
                                    className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn"
                                    onClick={() => handleSubmit()}
                                    type="button"
                                    color="primary"
                                >
                                    Volgende
                                </Button>
                            </div>
                            <Modal id={"tooltip"} isOpen={memoIsOpen} toggle={() => setMemoIsOpen(!memoIsOpen)} className="modal-dialog__over feedback-modal-style opmerking-modal-styling info-modal-width w-40">
                                <ModalHeader>
                                    <div className="modal-header-styling">
                                        Tekst e-mail wijzigen
                                    </div>
                                    <div className="cross-icon-color">
                                        <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={() => setMemoIsOpen(false)}> </i>
                                    </div>
                                </ModalHeader>

                                <ModalBody className="bg-white rounded">
                                    <div className="d-flex justify-content-center flex-column">
                                        <p className="travelCost-light-text fs-5 mb-3">Geachte heer/mevrouw,</p>
                                        <textarea onChange={(e) => {
                                            setFormDataState({ ...formDataState, informText: e.target.value })
                                        }}
                                            value={formDataState.informText}
                                            className="form-style opmerking-input-styling my-2 travelCost-light-text w-100"
                                            rows="6"
                                        ></textarea>
                                        <p className="travelCost-light-text fs-5 mt-2">Met vriendelijke groet,</p>
                                        <p className="travelCost-light-text fs-5">{communityData?.data?.nameCoordinator || ''}</p>
                                    </div>
                                    <ModalFooter>
                                        <Button className="d-flex align-items-center btn-color-style back-btn" size="sm" outline color="primary" onClick={() => setMemoIsOpen(false)}>
                                            Wijzigen
                                        </Button>
                                    </ModalFooter>
                                </ModalBody>
                            </Modal>
                        </div>
                    </CardFooter>
                </div>
            </div>
        </div>
    )
};

export default Step1;
